import { Box, Typography, Stack, CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useTranslation } from 'react-i18next';

export default function ScanImage(props: any) {
    const { item, isPlaceholder } = props;
    const { t } = useTranslation();
    const [loaded, setLoaded] = useState(false);
    const imgRef = useRef<HTMLImageElement | null>(null);

    // Reset the spinner when the source changes; images already cached won't fire onLoad, so detect them here.
    useEffect(() => {
        setLoaded(false);
        if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [item]);

    const handleDragStart = (e: any) => e.preventDefault();

    // Shared styles for image containers
    const imageContainerStyles = {
        width: '100%',
        aspectRatio: '16 / 9',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: 2,
        position: 'relative',
    };

    // If this is a placeholder image, render logo + text
    if (isPlaceholder) {
        return (
            <Stack
                sx={{
                    ...imageContainerStyles,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                }}
            >
                <Box
                    component="img"
                    src={item}
                    alt="Spectre Logo"
                    onDragStart={handleDragStart}
                    sx={{
                        maxWidth: '40%',
                        maxHeight: '50%',
                        objectFit: 'contain',
                        mb: 2,
                        borderRadius: '12px'
                    }}
                />
                <Typography
                    variant="h5"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center',
                        mt: 1,
                    }}
                >
                    {t('control.centerControl.awaitingScan')}
                </Typography>
            </Stack>
        );
    }

    // Normal image rendering
    return (
        <Box sx={imageContainerStyles}>
            {!loaded && (
                <CircularProgress
                    size={36}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'text.secondary',
                    }}
                />
            )}
            <Box
                component="img"
                ref={imgRef}
                src={item}
                alt="Scan image"
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
                onDragStart={handleDragStart}
                role="presentation"
                sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain', // maintain aspect ratio
                    display: 'block',
                    margin: 'auto',
                    borderRadius: '12px',
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity 200ms ease',
                }}
            />
        </Box>
    );
}